import React, { useContext } from "react";
import { ShoppingCartIcon } from "@heroicons/react/24/outline";
import { menuContext } from "../../Context/menuContex";
import { Link, useLocation } from "react-router-dom";
import logoLLama from "../../assets/Logo LLama Blanco Transparente.svg";
import logoName from "../../assets/Name blanco.svg";

export const Header = () => {
  const { toShoppin } = useContext(menuContext);
  const location = useLocation();
  return (
    <header className="bg-[#000000] text-white flex  w-screen h-10 z-10  fixed top-0">
      <Link to={"/"} className="flex   pl-2 top-2">
        <img loading="lazy" src={logoLLama} alt="logo" className=" " />
      </Link>
      <div className="  flex absolute right-[8px] top-2">
        <img
          loading="lazy"
          src={logoName}
          alt="Name"
          className=" w-20 object-contain mr-3"
        />
        <Link
          to={"/shoppingcart"}
          className="flex self-center relative  cursor-pointer pr-2"
        >
          {toShoppin.length != 0 && location.pathname !== "/shoppingcart" && (
            <span className="absolute w-5 h-5 left-1 inset-0 rounded-full  border-solid  border-2 border-gray-300 border-opacity-55 animate-ripple"></span>
          )}
          <ShoppingCartIcon className=" w-6  self-end relative " />
          <p className="  text-sm relative  top-[-6px]">{toShoppin.length}</p>
        </Link>
      </div>
    </header>
  );
};
